export const MODAL_DIALOG__CREATE_CAMPAIGN = 'MODAL_DIALOG__CREATE_CAMPAIGN';
export const MODAL_DIALOG__EDIT_CAMPAIGN = 'MODAL_DIALOG__EDIT_CAMPAIGN';
